import { render, staticRenderFns } from "./ChoresSkeleton.vue?vue&type=template&id=bd27aa0a&scoped=true"
import script from "./ChoresSkeleton.vue?vue&type=script&lang=js"
export * from "./ChoresSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ChoresSkeleton.vue?vue&type=style&index=0&id=bd27aa0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd27aa0a",
  null
  
)

export default component.exports